import AlertDataGrid from './AlertDataGrid';

export default AlertDataGrid;
export * from './AlertDataGrid';
